<template>

<com-item name="hindex.levels" :size="size" :is-empty="!active" :loading="loading" :no-hover="true" :is-container="true">

	<template v-slot:stats>

		<div class="levels">

			<div class="level" v-for="level in data" :key="level.id">

				<div class="level-value">{{ level.own.level }}</div>

				<com-overview 
					label="Date" 
					type="date" 
					:value="level.own.date" 
					:width="1"
					class="level-date"
				/>

				<template v-if="!publicIndex">

					<com-overview 
						label="Days" 
						type="number" 
						:value="level.own.days" 
						:width="1"
						info="The number of days needed to reach this level from the previous one."
						class="level-days"
						v-if="level.own.level > 1"
					/>

					<com-overview 
						label="Games" 
						type="number" 
						:value="level.own.games" 
						:width="1"
						info="The number of games played in the process of reaching this level."
						class="level-games"
						v-if="level.own.level > 1"
					/>

					<com-overview 
						label="Plays" 
						type="number" 
						:value="level.own.plays" 
						:width="1"
						info="The number of plays in the process of reaching this level."
						class="level-plays"
						v-if="level.own.level > 1"
					/>

					<com-overview 
						label="Efficiency" 
						type="percent" 
						:value="level.own.efficiency" 
						:width="1"
						info="How efficiently you reached the level compared to the minimum plays needed."
						class="level-efficiency"
						v-if="level.own.level > 1"
					/>

				</template>

				<template v-if="publicIndex">

					<com-overview 
						label="Days" 
						type="number" 
						:value="level.own.days" 
						:median="level.median.days"
						:percentile="level.percentile.days"
						:width="1"
						:compare="true"
						info="The number of days needed to reach this level from the previous one."
						class="level-days"
						v-if="level.own.level > 1"
					/>

					<com-overview 
						label="Games" 
						type="number" 
						:value="level.own.games" 
						:median="level.median.games"
						:percentile="level.percentile.games"
						:width="1"
						:compare="true"
						info="The number of games played in the process of reaching this level."
						class="level-games"
						v-if="level.own.level > 1"
					/>

					<com-overview 
						label="Plays" 
						type="number" 
						:value="level.own.plays" 
						:median="level.median.plays"
						:percentile="level.percentile.plays"
						:width="1"
						:compare="true"
						info="The number of plays in the process of reaching this level."
						class="level-plays"
						v-if="level.own.level > 1"
					/>

					<com-overview 
						label="Efficiency" 
						type="percent" 
						:value="level.own.efficiency" 
						:percentile="level.percentile.efficiency"
						:width="1"
						:compare="true"
						info="How efficiently you reached the level compared to the minimum plays needed."
						class="level-efficiency"
						v-if="level.own.level > 1"
					/>

				</template>
			
			</div>

		</div>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'
import comOverview from './../common/Overview'

export default {

	props: ['fetching', 'you', 'your', 'size'],

	components: {
		'com-item': comItem,
		'com-overview': comOverview
	},

	computed: {

		publicIndex: function() {

			return this.$store.getters['page/insights/hindex/public']

		},

		loading: function() {

			return this.fetching === 'all' || this.fetching === 'games'

		},

		data: function() {

			return this.$store.getters['page/insights/hindex/levels']

		},

		active: function() {

			return this.data.length && !this.loading

		}

	},

	methods: {

		onMoreClick: function() {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsHindexLevels'
			})

		}

	}

}

</script>

<style scoped>

.levels {
	display: grid;
	grid-template-columns: 1fr;
	grid-gap: 40px;
}

.level {
	display: grid;
	grid-gap: 10px;
	grid-template-columns: 104px 104px 1fr 1fr 1fr 1fr;
}

.level:nth-child(even):before {
	content: '';
	position: absolute;
	left: -40px;
	top: -20px;
	width: calc(100% + 80px);
	height: calc(100% + 40px);
	background-color: #f3f9fb;
}

.level:first-child {
	padding-top: 0px;
}

.level:last-child {
	border-bottom: 0px;
	padding-bottom: 0px;
}

@media only screen and (min-width: 601px) and (max-width: 1500px) {

	.level {
		grid-template-columns: 104px 1fr 1fr;
	}

	.level-date {
		order: 4;
	}

	.level-days {
		order: 2;
	}

	.level-games {
		order: 3;
	}

	.level-plays {
		order: 5;
	}

	.level-efficiency {
		order: 6;
	}

}

@media only screen and (min-width: 461px) and (max-width: 600px) {

	.level {
		padding: 20px 0px;
		grid-template-columns: 1fr 1fr;
	}

}

@media only screen and (max-width: 460px) {

	.level {
		padding: 20px 0px;
		grid-template-columns: 1fr;
	}

}

.level-value {
	font-size: 48px;
	color: #fff;
	line-height: 104px;
	text-align: center;
	background-color: #4881bb;
	font-weight: 700;
	border-radius: 4px;
}

</style>